export enum VoiceCallRecordCreationEnum {
  ClientSideCallCreation,
  ServerSideCallCreation
}
